import axios from "axios";
import { config } from "../utils/config";
import { getJwtTokenObject, setJwtTokenObject } from "../utils/jwt";
import { getAccessTokenApi } from "./auth";

const instance = axios.create({
  // baseURL: config.baseURL,
});

const attachInterceptors = () => {
  // ✅ Request interceptor
  instance.interceptors.request.use(
    (cfg) => {
      const tokenDetails = getJwtTokenObject();
      const accessToken = tokenDetails?.access_token;

      if (accessToken && !["/oauth/token"].includes(cfg.url)) {
        cfg.headers["Authorization"] = `Bearer ${accessToken}`;
      }

      return cfg;
    },
    (error) => Promise.reject(error)
  );

  // ✅ Response interceptor (refresh expired token)
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // Do not refresh when 403 is SCA-required (pantokens); let caller handle x-sca-session-code
      const scaSessionCode = error?.response?.headers?.["x-sca-session-code"];
      if (scaSessionCode) {
        return Promise.reject(error);
      }
      // Refresh logic for 403 / expired token
      if (
        !["/oauth/token"].includes(originalRequest.url) &&
        error?.response?.status === 403 &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;
        try {
          const res = await getAccessTokenApi();
          setJwtTokenObject(res);
          originalRequest.headers["Authorization"] = `Bearer ${res.access_token}`;
          return instance(originalRequest);
        } catch (refreshErr) {
          console.error("Token refresh failed:", refreshErr);
        }
      }

      return Promise.reject(error);
    }
  );
}

// Global switch for OAuth mode
if (config.mode === "oauth") {
  attachInterceptors();
} else {
  // ✅ Normal mode — no auth headers, no refresh logic
  console.log("Running in normal (non-OAuth) API mode");
}

const responseHandler = (res) => res.data;

const errorHandler = (err) => {
  console.error(err);
  throw err || new Error("Something went wrong!");
};

export const ajax = async (options) => {
  if (options?.authMode == "oauth") {
    attachInterceptors();
  }
  return instance(options).then(responseHandler).catch(errorHandler);
};

export default ajax;